import { Tabs } from 'libs/growth-platform-brand-system-v2/src/layouts/Tabs';
import { morphism } from 'morphism';
import React from 'react';
import { schemaTabsValueProposition } from '../../morphismSchema/templates/schemaTabsValueProposition';

export const TabsValuePropositionComponent = ({ block, locale }: any) => {
  return (
    <Tabs {...morphism(schemaTabsValueProposition, { ...block, locale })} />
  );
};

export default TabsValuePropositionComponent;
